import type Path from "@core/FileProvider/Path/Path";
import DefaultError from "@ext/errorHandlers/logic/DefaultError";
import ErrorType from "@ext/errorHandlers/model/ErrorTypes";
import t from "@ext/localization/locale/translate";
import type { ParsePosition } from "@ext/markdown/core/Parser/Error/ParsePosition";

export const FRONTMATTER_ERROR_CODE = "frontmatter-unreadable";

/** The article has no props, so it can be neither shown as itself nor written back. */
class FrontmatterError extends DefaultError {
	/** Counted in the file, not in the body — the properties stand above it — so it needs no shifting. */
	constructor(path: Path, reason: string, place?: { line?: number; content?: string }) {
		super(t("article.error.frontmatter"));
		this.name = "FrontmatterError";
		this.setProps({
			errorCode: FRONTMATTER_ERROR_CODE,
			path: path.value,
			reason,
			content: place?.content,
			...(place?.line && {
				position: { line: place.line, origin: "article", trustworthy: true } satisfies ParsePosition,
			}),
		});
	}

	get type() {
		return ErrorType.Frontmatter;
	}
}

export default FrontmatterError;
